import React from 'react';
import {useDispatch} from "react-redux";
import {openModal} from "@/Store/Slices/ModalSlice";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";

const MultipleRemoveCategories = ({checked}) => {
  const dispatch = useDispatch();

  const handleMultipleAction = () => {
    dispatch(openModal({
      modalType: 'multiple-coupon-modal',
      modalProps: {
        ids: checked,
        url: 'categories.multi.remove',
        text: 'Do you want to remove selected categories?',
      }
    }));
  }

  return (
    <button onClick={handleMultipleAction} className={'mr-3'} data-tip="Multiple remove categories">
      <FontAwesomeIcon
        color={'red'}
        size={'lg'}
        icon={solid('xmark')}/>
    </button>
  );
};

export default MultipleRemoveCategories;
